import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';

/**
 * Drop this next to any place the user's email is displayed - shows a small "Unverified" pill
 * when there's an email on file that Firebase hasn't confirmed yet, renders nothing otherwise
 * (no email at all, or already verified). Clicking navigates to /profile, the one place the real
 * verifyBeforeUpdateEmail workflow lives - this badge is a precise indicator, not a duplicate form.
 */
@Component({
  selector: 'app-email-verify-badge',
  imports: [],
  templateUrl: './email-verify-badge.html'
})
export class EmailVerifyBadge {
  authService = inject(AuthService);
  private router = inject(Router);

  onClick(): void {
    this.router.navigateByUrl('/profile');
  }
}
